import { useEffect } from "react";
import { ClientPortfoliosCard } from "./card";
import { ClientPortfoliosNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { ClientPortfoliosTable } from "./table";

export default function ClientPortfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles clients");
  }, []);

  return (
    <Routes>
      <Route index element={<ClientPortfoliosTable />} />
      <Route path="/new" element={<ClientPortfoliosNew />} />
      <Route path=":id" element={<ClientPortfoliosCard />} />
    </Routes>
  );
}
